import React from 'react';

import { useStyles } from '../../Home/Intro/styles/introCardStyles';

export const GraphLines = () => {
  const classes = useStyles();
  return (
    <svg
      className={classes.svgIcon}
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 512 512'
    >
      <path
        fill='#fff'
        opacity='1'
        d='M0 64L0 400c0 44.2 35.8 80 80 80l400 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 416c-8.8 0-16-7.2-16-16V64c0-17.7-14.3-32-32-32S0 46.3 0 64z'
      />
      <path
        className={classes.graphLines}
        fill='#0380B6'
        d='M480 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v224c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM288 160c0-17.7-14.3-32-32-32s-32 14.3-32 32v160c0 17.7 14.3 32 32 32s32-14.3 32-32V160zm-96 96c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32v-64zm160-64c-17.7 0-32 14.3-32 32v96c0 17.7 14.3 32 32 32s32-14.3 32-32v-96c0-17.7-14.3-32-32-32z'
      />
    </svg>
  );
};
